import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  heading: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingLeft: "35.22px",
    paddingRight: "35.22px",
  },
  icon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    marginTop: 0,
    height: 52,
  },
  titleText: {
    textAlign: "left",
    fontSize: 20,
    lineHeight: "26px",
    fontWeight: 400,
    letterSpacing: 0,
    color: "#484a56",
    opacity: 1,
    marginLeft: 15.17,
  },
  subTitleText: {
    textAlign: "left",
    fontSize: 16,
    lineHeight: "21px",
    letterSpacing: 0,
    color: "#484a56",
    opacity: 0.7,
    marginTop: 5,
    marginLeft: 15.17,
  },
  feedbackForm: {
    display: "flex",
    flexDirection: "column",
  },
  feedbackLabel: {
    position: "relative",
    transform: "none",
    textAlign: "left",
    fontSize: 14,
    lineHeight: "19px",
    letterSpacing: 0,
    color: "#484a56",
    opacity: 1,
    marginBottom: 10,
    marginTop: 30,
  },
  infoContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: 20,
    backgroundColor: "#ffad1026",
    borderRadius: 10,
  },
  infoIcon: {
    marginTop: 23,
    marginLeft: 15,
  },
  infoMessage: {
    fontSize: 14,
    lineHeight: "19px",
    color: "#484a56",
    textAlign: "left",
    marginLeft: 17,
    marginTop: 19,
    marginBottom: 19,
    marginRight: 29,
  },
  buttonContainer: {
    marginTop: 34,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: 50,
    marginBottom: 34,
  },
  disabledSubButton: {
    backgroundColor: "#ed4044",
  },
  modalWindow: {
    /* eslint-disable local/no-nested-selectors */
    "& .MuiFormControl-root": {
      display: "flex",
    },
    "& .MuiDialogContent-root": {
      padding: 0,
      flexDirection: "column",
    },
    "& .MuiPaper-root .close-button": {
      borderRadius: "10px",
    },
    "& .MuiPaper-root": {
      borderRadius: "20px",
      width: "520px",
      height: "auto !important",
    },
    /* eslint-enable local/no-nested-selectors */
  },
  formScrollView: {
    width: "auto !important",
    marginTop: "40.23px",
    paddingLeft: "35.22px",
    paddingRight: "35.22px",
  },
  circularProgress: {
    marginRight: "10px",
    color: "white",
  },
}));
